import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {ProAtributo} from "../types/ProAtributo.type";

@Injectable({
  providedIn: 'root'
})
export class ProatributoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAtributos(idAnalise: number) {
    return this.httpClient.get<ProAtributo[]>(`${this.configService.getApiUrlRoot()}/proanalise/atributos/${idAnalise}`);
  }
}
